import React from 'react'
import { Route, Switch } from 'react-router'
import MyClasses from '../pages/Class/MyClasses/MyClasses'
import { MyCoursesPage } from '../pages/Course/MyCourses'

const UserContentWrapper = () => {
    return (
        <Switch>
            <Route path={'/app/my-classes'} component={MyClasses} />
            <Route path={'/app/my-courses'} component={MyCoursesPage} />
        </Switch>
    )
}

export default UserContentWrapper
